import { ClassificationLevel } from '@types';
import { DateRangeQueryParams } from '@sonar-software/sonar-ts-types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

type DataSecuritySetupAuditTrailGraphClassification = {
	classification: ClassificationLevel;
	total: number;
};

export type DataSecuritySetupAuditTrailGraphResponse = {
	changeCount: number;
	classifications: DataSecuritySetupAuditTrailGraphClassification[];
};

export const getDataSecuritySetupAuditTrailGraph = createGetEndpoint<DateRangeQueryParams, DataSecuritySetupAuditTrailGraphResponse>(
	(request) => `/api/v3/setup-audit-trail/graph?${getQueryString(request)}`
);
